import type { SxProps, Theme } from "@mui/material";

export const settingsRowActionButtonSx: SxProps<Theme> = {
  textTransform: "none",
  fontWeight: 600,
  whiteSpace: "nowrap",
};
